// Color + gradient tokens — ported verbatim from mobile src/theme/colors.ts.
// Used wherever a component needs a color value in JS (metric colors, signal
// dots, chart hues). CSS-side tokens live in theme.css.

export const dark = {
  // Backgrounds
  bg: '#050609',
  surface: '#0D0F14',
  surfaceElevated: '#1C2230',
  surfaceElevated2: '#242B3A',
  surfaceSheet: '#1A2235',
  surfaceInput: '#1C2638',

  // Text
  textPrimary: '#E8EAF0',
  textSecondary: 'rgba(232,234,240,0.65)',
  textTertiary: 'rgba(232,234,240,0.38)',

  // Borders
  border: 'rgba(255,255,255,0.10)',
  borderSubtle: 'rgba(255,255,255,0.07)',
  borderExtraSubtle: 'rgba(255,255,255,0.05)',

  // Accents — semantic
  cyan: '#00C2D4',
  green: '#00E87A',
  red: '#FF5A5A',
  purple: '#A855F7',
  amber: '#FFB020',

  // Brand
  brandCyan: '#00BFFF',
  brandGreen: '#00E87A',
  brandPurp: '#A855F7',

  // Accent borders / backgrounds reused by selectors + dropdowns
  cyanBorder: 'rgba(0,194,212,0.45)',
  dropdownBg: '#1A2235',
} as const;

// Gradient color arrays. On web these feed a CSS linear-gradient string.
export const gradients = {
  brandMain: ['#00BFFF', '#00E87A'],
  borderDefault: ['#00BFFF', '#00E87A'],
  borderLong: ['#00BFFF', '#00E87A'],
  borderShort: ['#FF5A5A', '#FF3D3D', '#7B1A1A'],
  borderRed: ['#FF5A5A', '#7B1A1A'],
  borderPurple: ['#A855F7', '#4C1D8A'],
  borderAlerts: ['#FFB020', '#A855F7'],
  borderInvalidation: ['#FF5A5A', '#A855F7'],
  toggleOn: ['#00BFFF', '#00E87A'],
} as const;

export type Theme = typeof dark;
export type Gradients = typeof gradients;

/** Build a CSS linear-gradient() from a color array (mirrors RN LinearGradient). */
export function toLinearGradient(colors: readonly string[], angle = '135deg'): string {
  return `linear-gradient(${angle}, ${colors.join(', ')})`;
}
